import type { SpaceGroup } from "@circle-react/types/SpaceGroup";

import type { EditSpaceGroupModalTab } from "./constants";

export const EDIT_SPACE_GROUP_FORM_ID = "edit-space-group-form";

export interface EditSpaceGroupModalProps {
  spaceGroup: SpaceGroup;
  tab?: EditSpaceGroupModalTab;
}
